/**
 * 로컬 스토리지 키 상수 정의
 * 모든 localStorage 키는 이 클래스를 통해 관리됩니다.
 */
class LocalStorageKey {
}
// -------------------------------------------------------------------------
// 공통 (WTS, MTS)
// -------------------------------------------------------------------------
// 인증 관련
Object.defineProperty(LocalStorageKey, "ACCESS_TOKEN", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'access_token'
});
Object.defineProperty(LocalStorageKey, "ACCOUNT_TOKEN", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'account_token'
});
Object.defineProperty(LocalStorageKey, "SAVED_EMAIL", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'saved_email'
});
Object.defineProperty(LocalStorageKey, "SAVED_MEMBER_TYPE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'saved_member_type'
});
Object.defineProperty(LocalStorageKey, "MEMBER_TYPE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'member_type'
});
// 차트 관련
Object.defineProperty(LocalStorageKey, "GLOBAL_CHART_SETTINGS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'global-chart-settings'
});
Object.defineProperty(LocalStorageKey, "REALTIME_CONFIG", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'realtime-config'
});
Object.defineProperty(LocalStorageKey, "CHART_SYNC_GROUPS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'chart-sync-groups'
});
// 워크스페이스 관련
Object.defineProperty(LocalStorageKey, "MODA_WORKSPACES", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'moda_workspaces'
});
Object.defineProperty(LocalStorageKey, "CHART_WORKSPACES", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'chart-workspaces'
});
Object.defineProperty(LocalStorageKey, "CHART_CURRENT_WORKSPACE_ID", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'chart-current-workspace-id'
});
Object.defineProperty(LocalStorageKey, "SELECTED_ACCOUNT", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'selected_account'
});
// 주문 패널 관련
Object.defineProperty(LocalStorageKey, "AUTO_LIQUIDATION_ACCORDION_OPEN", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'auto-liquidation-accordion-open'
});
// 거래 모드 관련
Object.defineProperty(LocalStorageKey, "TRADE_MODE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'trade_mode'
});
// 계좌 비밀번호 입력 유도 팝업
Object.defineProperty(LocalStorageKey, "ACCOUNT_PASSWORD_POPUP_NEEDED", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'account_password_popup_needed'
});
Object.defineProperty(LocalStorageKey, "KYC_DOCUMENT_GUIDE_POPUP_NEEDED", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'kyc_document_guide_popup_needed'
});
/** 로그인 직후 홈에서 계좌 개설 다이얼로그 1회 노출용 */
Object.defineProperty(LocalStorageKey, "CREATE_ACCOUNT_DIALOG_POPUP_NEEDED", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'create_account_dialog_popup_needed'
});
// 잔고 테이블 정렬 상태
Object.defineProperty(LocalStorageKey, "BALANCE_TABLE_SORT_STATE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'balance_table_sort_state'
});
// 데스크톱 최초 홈 진입 여부
Object.defineProperty(LocalStorageKey, "FIRST_HOME_ENTRY_DONE", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'first_home_entry_done'
});
// -------------------------------------------------------------------------
// 모바일 전용 (MTS only)
// -------------------------------------------------------------------------
// 계좌 비밀번호 관련
Object.defineProperty(LocalStorageKey, "SAVED_ACCOUNT_PASSWORD", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'saved_account_password'
});
Object.defineProperty(LocalStorageKey, "SAVE_ACCOUNT_PASSWORD_AGREED", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'save_account_password_agreed'
});
// 주문 확인 바텀시트 "다시 보지 않기"
Object.defineProperty(LocalStorageKey, "DONT_SHOW_ORDER_CONFIRM", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'dont_show_order_confirm'
});
Object.defineProperty(LocalStorageKey, "DONT_SHOW_CLOSEOUT_CONFIRM", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'dont_show_closeout_confirm'
});
Object.defineProperty(LocalStorageKey, "DONT_SHOW_MARKET_CLOSEOUT_ALL_CONFIRM", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'dont_show_market_closeout_all_confirm'
});
Object.defineProperty(LocalStorageKey, "DONT_SHOW_CANCEL_ALL_CONFIRM", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'dont_show_cancel_all_confirm'
});
export default LocalStorageKey;
//# sourceMappingURL=local-storage-key.js.map